import type { SVGProps } from 'react';
const SvgSettingsPower = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#settings_power_svg__a)">
      <path
        fill="currentColor"
        d="M7 24h2v-2H7v2Zm4 0h2v-2h-2v2Zm2-22h-2v10h2V2Zm3.56 2.44-1.45 1.45A5.969 5.969 0 0 1 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44A7.961 7.961 0 0 0 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56ZM15 24h2v-2h-2v2Z"
      />
    </g>
    <defs>
      <clipPath id="settings_power_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSettingsPower;
